export default __webpack_public_path__ + "static/media/develop.11642a00.jpg";